import React, { useContext } from 'react';
import { Typography } from 'antd';
import { UserContext } from '../App';
import AgentDetailPanel from '../components/AgentDetailPanel';

export default function AgentSummaryPageNew() {
  const currentUser = useContext(UserContext);

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          My Summary
        </Typography.Title>
      </div>

      {currentUser?.ID && (
        <AgentDetailPanel
          agentUserId={currentUser.ID}
          agentRecord={null}
          canCreateIncident={false}

          hideCCaasStatus={!!currentUser?.TeamHideCCaasStatus}
          hideUpsell={!!currentUser?.TeamHideUpsell}
          hideAdherenceMonthlyTables
        />
      )}
    </>
  );
}
